export default {
    required: ({ required, showInitializationErrors, errorMessage, messages, name, props }) => {
        return function requiredValidation(value, changedEver) {

            const isEmptyArray = (props.multiple && !value?.length)
            const isExist = (value !== null && value !== undefined && value !== false && value !== '' && !isEmptyArray)
            const isError = ((changedEver || !changedEver && showInitializationErrors) && !isExist && required)

            return {
                error: isError,
                errorMessage: isError ? (errorMessage ? errorMessage : messages[name + 'ValidationRequired'] ? messages[name + 'ValidationRequired']({ value }) : '') : ''
            }
        }
    },
    lengthText: ({ showInitializationErrors, errorMessage, messages, name, min, max }) => {
        return function lengthTextValidation(value, changedEver) {
            const isError = (
                (min >= 1 && (changedEver || !changedEver && showInitializationErrors) && value?.length && value.length < min) ||
                (max >= 1 && (changedEver || !changedEver && showInitializationErrors) && value?.length && value.length > max)
            )
            return {
                error: isError,
                errorMessage: isError ? (errorMessage ? errorMessage : messages[name + 'ValidationLengthText'] ? messages[name + 'ValidationLengthText']({
                    min,
                    max,
                    value
                }) : '') : ''
            }
        }
    },
    numberRange: ({ showInitializationErrors, errorMessage, messages, name, min, max }) => {
        return function numberRangeValidation(value, changedEver) {

            const isError = (
                (typeof min === 'number' && (changedEver || !changedEver && showInitializationErrors) && (value || value === 0) && value < min) ||
                (typeof max === 'number' && (changedEver || !changedEver && showInitializationErrors) && (value || value === 0) && value > max)
            )

            return {
                error: isError,
                errorMessage: isError ?
                    (errorMessage ? errorMessage : messages[name + 'ValidationNumber'] ? messages[name + 'ValidationNumber']({
                        min,
                        max,
                        value
                    }) : '')
                    : ''
            }
        }
    },
    arrayLength: ({ showInitializationErrors, errorMessage, messages, name, min, max }) => {
        return function arrayLengthValidation(value, changedEver) {

            const isError = (
                (min >= 1 && (changedEver || !changedEver && showInitializationErrors) && value?.length && value.length < min) ||
                (max >= 1 && (changedEver || !changedEver && showInitializationErrors) && value?.length && value.length > max)
            )

            return {
                error: isError,
                errorMessage: isError ?
                    (errorMessage ? errorMessage : messages[name + 'ValidationLengthArray'] ? messages[name + 'ValidationLengthArray']({
                        min,
                        max,
                        value
                    }) : '')
                    : ''
            }
        }
    },
    regex: ({ showInitializationErrors, errorMessage, messages, name, pattern, flags, props }) => {
        return function regexValidation(value, changedEver) {

            if (pattern && (changedEver || !changedEver && showInitializationErrors)) {

                let validByPattern = true

                const regex = new RegExp(pattern, flags)

                if (props.multiple) {

                    if (value) {

                        if (value.filter((item) => {
                            const string = item && item.toString ? item.toString() : ''
                            const isError = !string.match(regex)
                            return !isError
                        }).length !== value.length) {
                            validByPattern = false
                        }

                    }

                } else {

                    if ((typeof value === 'string' && value) || typeof value === 'number') {

                        const string = (value || value === 0) && value.toString ? value.toString() : ''

                        const isError = !string.match(regex)
                        if (isError) {
                            validByPattern = false
                        }

                    }

                }

                if (!validByPattern) {

                    return {
                        error: true,
                        errorMessage: errorMessage ?
                            errorMessage :
                            messages[name + 'ValidationRegex'] ?
                                messages[name + 'ValidationRegex']({ pattern, value }) :
                                ''
                    }

                }

            }

            return { error: false, errorMessage: '' }
        }
    }
}
